export default class CommonUtils {
  static setValueInPath (context, fieldPath, fieldValue) {
    let fields = fieldPath.split('.');
    let obj = context;

    for (let i = 0; i < fields.length - 1; i++) {
      if (!obj[fields[i]]) {
        Vue.set(obj, fields[i], {});
      }
      obj = obj[fields[i]];
    }

    Vue.set(obj, fields[fields.length - 1], fieldValue);
  }
}